import { checkoutActionType } from 'constants/checkoutActionType';
export var addToBag = function (Post) {
    return {
        type: checkoutActionType.ADD_TO_CART,
        payload: Post
    };
};
export var RemoveFromBag = function (Post) {
    return {
        type: checkoutActionType.REMOVE_FROM_CART,
        payload: Post
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/checkoutActions.ts
// module id = 927
// module chunks = 0 1 2 3 4 5 6 7